import React from 'react';
import { Link } from 'react-router-dom';

export interface ContentWrapperProps<RecordType> {
  record: RecordType;
  index: number;
  getRowLink?: (record: RecordType) => string;
  pageUrl?: string;
  render: (record: RecordType, index: number) => React.ReactNode;
  notLinked?: boolean;
  onClick?: (record: RecordType) => void;
  contentClassName?: string;
}

const ContentWrapper = <RecordType,>({
  record,
  index,
  getRowLink,
  pageUrl,
  render,
  notLinked,
  onClick,
  contentClassName,
}: ContentWrapperProps<RecordType>) => {
  const className = `text-gray-800 ${
    contentClassName ?? 'block pl-6 pr-1 py-3'
  }`;

  return (
    <>
      {getRowLink && !notLinked ? (
        <Link
          className={className}
          key={index}
          to={{
            pathname: getRowLink(record),
          }}
          state={{ prevPage: pageUrl }}>
          {render(record!, index)}
        </Link>
      ) : (
        <div
          className={className}
          key={index}
          onClick={() => onClick?.(record)}>
          {render(record!, index)}
        </div>
      )}
    </>
  );
};

export default ContentWrapper;
